var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoOptionsMenuEp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.15 33.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#412878;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico-options-menu-ep") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 33.15,
    height: 33.17,
    rx: 16.58
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-more",
    "data-name": "Icon ionic-md-more",
    className: "cls-2",
    d: "M19.33,8.33a2.75,2.75,0,1,0-2.75,2.75A2.75,2.75,0,0,0,19.33,8.33Zm0,16.5a2.75,2.75,0,1,0-2.75,2.75A2.75,2.75,0,0,0,19.33,24.83Zm0-8.25a2.75,2.75,0,1,0-2.75,2.75A2.75,2.75,0,0,0,19.33,16.58Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoOptionsMenuEp);
export default __webpack_public_path__ + "static/media/ico-options-menu-ep.a6af3ef98998c123011e9c990f66bbee.svg";
export { ForwardRef as ReactComponent };